/*
 * File: PaymentCancel.styles.js
 * Project: lets-talk-web
 */

// Modules
import styled from 'styled-components';
import { Button, Padding } from '../../../components';
import { mobileBreakpoint } from '../../../styles/constants';

export const Wrapper = styled(Padding)`
	min-height: 70vh;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	z-index: 2;
`;

export const Card = styled.div`
	width: 100%;
	max-width: 620px;
	background: ${({ theme }) => theme.cardBackground};
	border: 1px solid ${({ theme }) => theme.borderPrimary};
	border-radius: 18px;
	padding: 32px 24px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
	text-align: center;

	@media only screen and (min-width: ${mobileBreakpoint}em) {
		padding: 42px 40px;
	}

	h2 {
		margin: 0 0 12px;
	}

	p {
		margin: 0;
		color: ${({ theme }) => theme.secondaryText};
	}
`;

export const IconWrapper = styled.div`
	display: flex;
	justify-content: center;
	margin-bottom: 18px;
`;

export const ErrorCircle = styled.div`
	width: 58px;
	height: 58px;
	border-radius: 50%;
	background: #fff4f4;
	border: 2px solid #ff6363;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const ErrorMark = styled.span`
	font-size: 30px;
	font-weight: 700;
	line-height: 1;
	color: #d63f3f;
	position: relative;
	top: -1px;
`;

export const ButtonGroup = styled.div`
	margin-top: 28px;
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

/** Primary CTA — filled, full width (was the secondary action’s role before reorder) */
export const PrimaryActionButton = styled(Button)`
	width: 100%;
`;

/** Secondary — text / subtle (was the primary action’s role before reorder) */
export const SecondaryTextButton = styled(Button).attrs({ variant: 'text' })`
	width: 100%;
`;
